import { ensureAnonymousSession } from "@/api/auth";
import { useAuthStore } from "@/stores/use-auth-store";
import { toast } from "shared-components";

export const useUserIdentityCookie = () => {
  const { isAuthenticated } = useAuthStore();

  /**
   * @description Retorna `true` quando usuário já tem cookie de identidade:
   * - auth_token para usuário autenticado
   * - anonymous_user_id para visitante
   *
   * @note Para visitante, tenta criar `anonymous_user_id` antes de retornar.
   */
  const ensureUserIdentityCookie = async (): Promise<boolean> => {
    if (isAuthenticated) {
      return true;
    }

    const anonymousSession = await ensureAnonymousSession();
    if (anonymousSession.error?.message) {
      toast.error(anonymousSession.error.message);
      return false;
    }

    return true;
  };

  return { ensureUserIdentityCookie };
};
